import "swiper/css/bundle";
import classNames from "classnames";
import useBreakpoints from "hooks/useBreakpoints";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination } from "swiper/modules";
import { Card } from "../Card";
import { CarouselStyled } from "./styles";
interface CarouselProps {
	items?: {
		image: string;
		title: string;
		description?: string;
	}[];
}

export const Carousel: React.FC<CarouselProps> = ({ items }) => {
	const { isSmDown } = useBreakpoints();

	return (
		<CarouselStyled className={classNames([isSmDown && "mobile"])}>
			<Swiper
				slidesPerView={1.2}
				spaceBetween={0}
				freeMode={false}
				modules={[FreeMode, Pagination]}
				className="mySwiper"
			>
				{items?.map((card, index) => (
					<SwiperSlide key={index} style={{ marginRight: "2rem" }}>
						<Card item={card} />
					</SwiperSlide>
				))}
			</Swiper>
		</CarouselStyled>
	);
};
